module.exports = __webpack_public_path__ + "img/notfound.6e057073.png";